import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';

import { renderTags } from './utils';

const CarbonCopyInput = ({ options = [], textFieldProps = {}, ...rest }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center'
			}}
		>
			<Autocomplete
				multiple
				freeSolo
				options={options}
				renderTags={renderTags}
				renderInput={params => (
					<TextField
						{...params}
						variant="filled"
						{...textFieldProps}
						sx={{
							...textFieldProps.sx,
							'& .MuiAutocomplete-hasClearIcon': {
								paddingBottom: '5px',
								paddingTop: '5px'
							}
						}}
					/>
				)}
				getOptionLabel={option => {
					if (typeof option === 'string') {
						return option;
					}

					return option.email;
				}}
				{...rest}
				sx={{
					...rest.sx,
					flexGrow: 1
				}}
			/>
			<Tooltip
				title={`After you finish typing the email press "Enter" key in order to paste email address to CC input`}
			>
				<IconButton>
					<HelpOutlineIcon />
				</IconButton>
			</Tooltip>
		</Box>
	);
};

export default CarbonCopyInput;
